export const EDeadlineStatus = {
  Upcoming: "Upcoming",
  Late: "Late",
  Complete: "Complete",
} as const;

export type EDeadlineStatusAlias =
  (typeof EDeadlineStatus)[keyof typeof EDeadlineStatus];
